/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Application_Submit_Error_AlertInputs */

const en_application_submit_error_alert = /** @type {(inputs: Application_Submit_Error_AlertInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to submit application. Please try again.`)
};

const de_application_submit_error_alert = /** @type {(inputs: Application_Submit_Error_AlertInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bewerbung konnte nicht abgeschickt werden. Bitte versuchen Sie es erneut.`)
};

/**
* | output |
* | --- |
* | "Failed to submit application. Please try again." |
*
* @param {Application_Submit_Error_AlertInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const application_submit_error_alert = /** @type {((inputs?: Application_Submit_Error_AlertInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Application_Submit_Error_AlertInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_application_submit_error_alert(inputs)
	return en_application_submit_error_alert(inputs)
});